// extracted by mini-css-extract-plugin
module.exports = {"form-group":"PhoneNumberInput_form-group__ysU18","form-control":"PhoneNumberInput_form-control__YJ2Bg","select-custom":"PhoneNumberInput_select-custom__u2VvY"};